
const tabsOptions = [
  {
    id: 1,
    title: "Customer Station Faults",
    icon: "cfacility-fault-icon",
    url: "customerfacilityfault",
    tab: "userCF"
  },
  {
    id: 2,
    title: "Customer Train Faults",
    icon: "ctrain-fault-icon",
    url: "customertrainfault",
    tab: "userCT"
  },
  {
    id: 3,
    title: "Customer Suggestions",
    icon: "zmdi zmdi-thumb-up suggestion",
    url: "suggestions",
    tab: "userCS"
  },
];

const facilityFaultLiveFilters = [
  { id: 1, filterTitle: "All Faults" },
  { id: 2, filterTitle: "Last 6 Months" },
  { id: 3, filterTitle: "Past Year" },
];
const facilityFaultArchivesFilters = [
  { id: 11, filterTitle: "All Faults" },
  { id: 22, filterTitle: "Last 6 Months" },
  { id: 33, filterTitle: "Past Year" },
];

const addReport = {
  title: "Add Report",
  topSection: {
    type: "input",
    inputLabel: "Report Name",
    inputPlaceHolder: "Report Name",
  },
  filters: {
    filterLabel: "Match",
    filterOptions: ["ANY", "ALL"],
    inputRowType: "input",
    condition: "OR",
  },
};


const editReport = {
    title: "Edit Report",
    topSection: {
      type: "input",
      inputLabel: "Report Name",
      inputPlaceHolder: "Report Name",
    },
    filters: {
      filterLabel: "Match",
      filterOptions: [
        { id: 101, value: "Any" },
        { id: 102, value: "All" },
      ],
      rowFiltersOptionsFirst: [
        { id: 201, value: "Details" },
        { id: 202, value: "Email" },
        { id: 203, value: "Mobile number" },
        { id: 204, value: "Name" },
        { id: 205, value: "Opted For Update" },
        { id: 206, value: "Reported To Staff" },
        { id: 207, value: "Station" },
        { id: 208, value: "Status" },
        { id: 209, value: "Date" },
        { id: 210, value: "Reference id" },
      ],
      rowFiltersOptionsSecond: [
        { id: 211, value: "is between" },
        { id: 212, value: "is" },
        { id: 213, value: "is not" },
        { id: 214, value: "is on or before" },
        { id: 214, value: "is on or after" },
      ],
      inputRowType: "date",
      condition: "AND",
    },
  };



  const detailTabsOptions = [
    {
      id: 101,
      title: "Fault Details",
      suggTitle: "Customer Suggestion Details",
      icon: "",
    },
    {
      id: 102,
      title: "Fault History",
      suggTitle: "Customer Suggestion History",
      icon: "",
    },
  ];


export { tabsOptions, facilityFaultLiveFilters, facilityFaultArchivesFilters, addReport, editReport, detailTabsOptions };
